import { FF } from 'modules/feature-flags/featureFlags.generated';
import { useSplitFlag } from 'modules/feature-flags/useSplitFlag';
import { useMemo } from 'react';
import { CacheStrategy } from 'modules/viewer/PixelCacheStategy';
import { ViewerDownloadingFlags } from 'modules/viewer/workers/pixelDataSharedWorkerTypes';

export function useViewerDownloadingFlags(): [ViewerDownloadingFlags, boolean] {
  const [cacheStrategy, loadingCacheStrategy] = useSplitFlag<CacheStrategy>(
    FF.VIEWER_CACHE_STRATEGY
  );
  const [maxParallelRequestsTreatment, loadingMaxParallelRequests] = useSplitFlag(
    FF.VIEWER_MAX_PARALLEL_PIXEL_REQUESTS
  );

  return useMemo(() => {
    return [
      {
        cacheStrategy,
        maxParallelRequests: parseMaxParallelRequests(maxParallelRequestsTreatment),
      },
      loadingCacheStrategy || loadingMaxParallelRequests,
    ];
  }, [
    cacheStrategy,
    maxParallelRequestsTreatment,
    loadingCacheStrategy,
    loadingMaxParallelRequests,
  ]);
}

// 'off', 'control', or anything that isn't a positive integer keeps the worker default.
function parseMaxParallelRequests(treatment: string): Nullable<number> {
  const limit = Number(treatment);
  if (!Number.isInteger(limit) || limit < 1) return null;
  return limit;
}
